module.exports = __webpack_public_path__ + "static/media/onboarding_3.d66013f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/onboarding_3.png
// module id = 434
// module chunks = 49